export default {
  title: 'Aggiungi file: {{slot}}',
  replace_title: 'Sostituisci file: {{slot}}',
  replace_description: 'Il nuovo file sostituisce questo. Conserviamo il vecchio nei nostri archivi.',
  form: {
    kind: {
      label: 'Tipo di documento',
      options: {
        passport: 'Passaporto',
        driver_license: 'Patente di guida',
        id_card: "Carta d'identità",
        residence_permit: 'Permesso di soggiorno',
      },
    },
    front: {
      label: 'Fronte',
    },
    back: {
      label: 'Retro',
    },
    file: {
      label: 'File',
    },
    expires_at: {
      label: 'Valido fino al',
      placeholder: 'Seleziona una data',
    },
    holder: {
      label: 'Di chi è questo documento?',
      options: {
        owner: 'Mio, del titolare',
        partner: 'Di un socio',
      },
    },
    holder_name: {
      label: 'Nome del socio',
      placeholder: 'Nome e cognome',
    },
  },
  accepted_files: 'PDF, JPG o PNG, fino a {{max}} MB.',
  accepted_images_min: 'Una foto deve essere di almeno {{min}} KB.',
  errors: {
    file_type: 'Sono accettati solo file PDF, JPG o PNG.',
    file_too_large: 'Il file supera {{max}} MB.',
    file_too_small: 'Una foto deve essere di almeno {{min}} KB.',
  },
  buttons: {
    select_file: 'Seleziona file',
    submit: 'Carica',
    cancel: 'Annulla',
  },
  toasts: {
    success: 'File caricato',
    error: 'Impossibile caricare il file.',
  },
};
